import axios from '../axios';
const apiPath = 'api/admin/notifications';

const notificationApi = {
    broadcast: entity => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/broadcast`,
            { ...entity }
        );
    }
};

export default notificationApi;
